import React from 'react';

import PropTypes from 'prop-types';

const DropdownSelect = ({ options, ref, ...inputProps }) => {
    let opts = [
        <option key="option-header-title" value="" />,
    ];

    opts = opts.concat(options.map((item) => (
        <option key={`option-${item.id}`} value={item.id}>
            { item.title }
        </option>
    )));

    return (
        <select
            ref={ref}
            className="form-dropdown select-hidden"
            {...inputProps}
        >
            { opts }
        </select>
    );
};

DropdownSelect.propTypes = {
    name: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        title: PropTypes.string.isRequired,
    })).isRequired,
};

export default React.memo(DropdownSelect);
